module.exports = __webpack_public_path__ + "img/navball_edited.dfb46f68.png";